import React, { useMemo, useState, useEffect } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { Topbar } from "./Topbar";
import { HeaderMenuWrapper } from "./header-menu/HeaderMenuWrapper";
import { AnimateLoading } from "../../../_partials/controls";
import { getTokenClaims } from "../../../../app//services/auth.service";
import { useSelector } from "react-redux";

export function Header(props) {
  const uiService = useHtmlClassService();
  const jsonFile = useSelector((state) => state.style);
  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses("header", true),
      headerAttributes: uiService.getAttributes("header"),
      headerContainerClasses: uiService.getClasses("header_container", true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        "header.menu.self.display"
      ),
    };
  }, [uiService]);
  let ApiUrl = `${process.env.REACT_APP_API_END_POINT}`;
  let supplierName = getTokenClaims()?.supplierName;
  let title = (
    <p
      style={
        jsonFile?.headerTitleColor
          ? { color: jsonFile?.headerTitleColor, marginTop: "15px" }
          : { marginTop: "15px" }
      }
    >
      <span
        dangerouslySetInnerHTML={{ __html: jsonFile?.mainHeaderTitle }}
      ></span>
      {/* <b style={{ fontSize: "18px" }}>({supplierName})</b> */}
    </p>
  );
  if (ApiUrl.includes("refactor")) {
    title = (
      <p
        style={
          jsonFile?.headerTitleColor
            ? { color: jsonFile.headerTitleColor, marginTop: "15px" }
            : { color: "red", marginTop: "15px" }
        }
      >
        <span
          dangerouslySetInnerHTML={{ __html: jsonFile?.headerTitle }}
        ></span>
        {/* <b style={{ fontSize: "18px" }}>({supplierName})</b> */}
      </p>
    );
  } else {
    title = (
      <p
        style={
          jsonFile?.mainheaderTitleColor
            ? { color: jsonFile?.mainheaderTitleColor, marginTop: "15px" }
            : { marginTop: "15px" }
        }
      >
        <span
          dangerouslySetInnerHTML={{ __html: jsonFile?.mainHeaderTitle }}
        ></span>
        {/* <b style={{ fontSize: "18px" }}>({supplierName})</b> */}
      </p>
    );
  }
  return (
    <>
      {/*begin::Header*/}
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        {/*begin::Container*/}
        <div
          className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-between`}
        >
          <b
            className="d-flex colorTitle align-items-center textFont16 "
            style={{ direction: "rtl" }}
          >
            {title}{" "}
          </b>
          <AnimateLoading />
          {/*begin::Header Menu Wrapper*/}
          {/* {layoutProps.menuHeaderDisplay && <HeaderMenuWrapper />} */}
          {layoutProps.menuHeaderDisplay && <b />}
          <Topbar refreshQuickCartable={props.refreshQuickCartable} />
          {!layoutProps.menuHeaderDisplay && <div />}
          {/*end::Header Menu Wrapper*/}

          {/*begin::Topbar*/}
          {/*end::Topbar*/}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Header*/}
    </>
  );
}
